export const globalSettingsSystemImportExternalRoute = {
	name: 'global-settings-system-import-external',
	path: '/secure/admin/ExternalImport1.jspa',
};
